import { render } from "./ConsumerReviews.vue?vue&type=template&id=4c601f8f"
import script from "./ConsumerReviews.vue?vue&type=script&lang=js"
export * from "./ConsumerReviews.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__